document.addEventListener('DOMContentLoaded', () => {
    const currentUrl = new URL(window.location.href);
    const utmParams = [...currentUrl.searchParams.entries()]
        .filter(([key]) => key.toLowerCase().startsWith('utm_'));
    const parentUrlValue = currentUrl.origin + currentUrl.pathname + currentUrl.hash;

    const isUrl = (url) => {
        if (!url) return false;
        const trimmed = String(url).trim();
        if (trimmed === '' || trimmed.startsWith('#')) return false;
        if (/^(mailto:|tel:|javascript:|sms:|data:)/i.test(trimmed)) return false;

        try {
            const linkUrl = new URL(trimmed, window.location.origin);
            return linkUrl.protocol === 'http:' || linkUrl.protocol === 'https:';
        } catch (e) {
            return false;
        }
    };

    const addUtmParams = (url, includeParent) => {
        const linkUrl = new URL(url, window.location.origin);
        utmParams.forEach(([key, value]) => {
            linkUrl.searchParams.set(key, value);
        });
        if (includeParent && !linkUrl.searchParams.has('parent_url')) {
            linkUrl.searchParams.set('parent_url', parentUrlValue);
        }
        return linkUrl.toString();
    };

    document.querySelectorAll('a[href]').forEach(link => {
        const href = link.getAttribute('href');
        const isPopup = link.getAttribute('data-popup') != null;
        if (isUrl(href)) {
            link.setAttribute('href', addUtmParams(href, isPopup));
            if (isPopup) {
                link.setAttribute('data-popup', addUtmParams(href, true));
            }
        }
    });

    document.querySelectorAll('iframe[src]').forEach(link => {
        const src = link.getAttribute('src');
        if (isUrl(src)) {
            link.setAttribute('src', addUtmParams(src, true));
        }
    });
});
